import store from "store2"

import grid from './grid/grid'

export default function(o, done){

  var lang = o.store('lang')

  var sponsorsLabel = o.util.getTranslation(o, 'sponsors')

  document.title = `Open Memory Box | ${sponsorsLabel}`

  var results = [
    {
      "image": 'logo-01-stiftung-aufarbeitung.png',
      "title": 'Bundesstiftung zur Aufarbeitung der SED-Diktatur',
      "link": 'https://www.bundesstiftung-aufarbeitung.de',
    },
    {
      "image": 'logo-03-daad.png',
      "title": 'Deutscher Akademischer Austauschdienst',
      "link": 'https://www.daad.de',
    },
    {
      "image": 'logo-02-canada.png',
      "title": 'Social Sciences and Humanities Research Council of Canada',
      "link": 'http://www.sshrc-crsh.gc.ca',
    },
    {
      "image": 'logo-05-bbf.png',
      "title": 'Bundesministerium für Bildung und Forschung',
      "link": 'https://www.bmbf.de',
    },
    {
      "image": 'logo-06-zzf.png',
      "title": 'Zentrum für Zeithistorische Forschung Potsdam',
      "link": 'https://zzf-potsdam.de',
    },
    {
      "image": 'logo-04-universite-montreal.png',
      "title": 'Université de Montréal',
      "link": 'https://www.umontreal.ca',
    },
    {
      "image": 'logo-07-irtg.png',
      "title": 'IRTG Diversity',
      "link": 'http://www.irtg-diversity.com',
    },
    {
      "image": 'logo-08-cceae.png',
      "title": 'Centre canadien d’études allemandes et européennes',
      "link": 'https://cceae.umontreal.ca',
    },
  ]

  var gridDiv = grid(o, results)

  var div = $('<div>')
  .css(o.mainDivCss)
  .addClass('iphoneNavbarFixTop')
  .addClass('iphoneNavbarFixBottom')  
  .append([

    o.component.menu(o)
    .css({
      flex: '0 0 auto',
      width: '100%',
      zIndex: 1,
    }),

    $('<div>')
    .css({
      flex: '1 1 auto'
    }),

    gridDiv
    .css({
      flex: '0 1 auto',
      width: '100%',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      minHeight: 0,
      zIndex: 1,
    }),

    $('<div>')
    .css({
      flex: '1 1 auto',
    }),

  ])

  var observer =
    new MutationObserver(function(){
      if (document.body.contains(div[0])){

        observer.disconnect()

        gridDiv.update()

      }
    })

  observer.observe(document.body, {childList: true});

  done(div)

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/sponsors/sponsors.js